import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { ChangeDetectorRef, Directive, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as moment from 'moment';

export const maxDateValidator = (value: Date): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors => {
    if (!control.value) {
      return null;
    }
    else {
      const date: Date = control.value;
      return moment(date).isAfter(value, 'day') ? { maxDate: true } : null;
    }
  };
};

@Directive({
  selector: '[appMaxDate][formControlName],[appMaxDate][formControl],[appMaxDate][ngModel]',
  providers: [
      {
        provide: NG_VALIDATORS,
        useExisting: MaxDateValidator,
        multi: true
      }
    ]
})
export class MaxDateValidator implements Validator, OnInit, OnChanges {

  @Input()
  public appMaxDate: Date;

  private validator: ValidatorFn;

  private onChange: () => void;

  constructor(private changeDetector: ChangeDetectorRef) {
  }

  public ngOnInit():void {
    this.validator = maxDateValidator(this.appMaxDate);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    for (const key in changes) {
      if (key === 'appMaxDate') {
        this.validator = maxDateValidator(changes[key].currentValue);
        if (this.onChange) {
          this.onChange();
          this.changeDetector.detectChanges();  //  there are some issues in angular with detecting valid/invalid state and binding to ngClass, for example. This fixes it.
        }
      }
    }
  }

  public validate(control: AbstractControl): ValidationErrors | null {
    return this.appMaxDate !== null ? this.validator(control) : null;
  }

  public registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }
}
